import axios from './axiosConfig';

const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";

// Get all SOA controls
export const getSOAControls = () => async (dispatch, getState) => {
    try {
        const response = await axios.get(API_URL + '/api/soa/controls');
        return response.data;
    } catch (error) {
        console.error('Error getting SOA controls:', error);
        throw error;
    }
};

// Get SOA statistics
export const getSOAStats = () => async (dispatch, getState) => {
    try {
        const response = await axios.get(API_URL + '/api/soa/stats');
        return response.data;
    } catch (error) {
        console.error('Error getting SOA stats:', error);
        throw error;
    }
};

// Update a SOA control
export const updateSOAControl = (soa_id, data) => async (dispatch, getState) => {
    try {
        const response = await axios.put(API_URL + `/api/soa/controls/${soa_id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating SOA control:', error);
        throw error;
    }
};

// Add a risk to a SOA control
export const addRiskToSOAControl = (soa_id, risk_id) => async (dispatch, getState) => {
    try {
        const response = await axios.post(API_URL + '/api/soa/controls/add-risk', { soa_id, risk_id });
        return response.data;
    } catch (error) {
        console.error('Error adding risk to SOA control:', error);
        throw error;
    }
};

// Remove a risk from a SOA control
export const removeRiskFromSOAControl = (soa_id, risk_id) => async (dispatch, getState) => {
    try {
        const response = await axios.post(API_URL + '/api/soa/controls/remove-risk', { soa_id, risk_id });
        return response.data;
    } catch (error) {
        console.error('Error removing risk from SOA control:', error);
        throw error;
    }
};
